import { OrderDetailModel, OrderListItemModel } from '@/model/order';
import { ResultModel } from '@/model/viewModel';
import { ApiResult, post } from '@/utils/api';

export const fetchAddCart = (data: any): Promise<ApiResult<number>> =>
  post<number>('/shop/cart/insert', data);

export const fetchCartList = (data: any): Promise<ApiResult<any>> =>
  post<any>('/shop/cart/select', data);

export const fetchCartEdit = (data: any): Promise<ApiResult<any>> =>
  post<any>('/shop/cart/edit', data);

export const fetchCartDelete = (data: any): Promise<ApiResult<any>> =>
  post<any>('/shop/cart/delete', data);

export const fetchCartClear = (data: any): Promise<ApiResult<any>> =>
  post<any>('/shop/cart/clear', data);

export const fetchAddOrder = (data: any): Promise<ApiResult<any>> =>
  post<number>('/order/insert', data);

export const fetchAddFoodWithOrder = (data: any): Promise<ApiResult<any>> =>
  post<number>('/order/food/insert', data);

export const getOrderList = (data: any): Promise<ApiResult<ResultModel<OrderListItemModel>>> =>
  post<ResultModel<OrderListItemModel>>('/order/select', data);

export const getOrder = (data: any): Promise<ApiResult<OrderDetailModel>> =>
  post<OrderDetailModel>('/order/selectOne', data);
